import React from 'react';
import { Center, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useOnMount } from 'clipsal-cortex-utils/src/hooks/use-on-mount';

import { ArcButton } from '../../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../../common/components/SlidingAnimationPageBase';
import { useParamBackUrl } from '../../../../common/hooks/use-param-back-url';
import { createLocationPermissionIcon } from '../../../../styles/create-location-permission-icon';
import { trackLocationPermissionOutcome } from '../../../../utils/common/analytics';
import {
  resetOnboardingFunnelTimer,
  trackDynatraceLocationPermissionOutcome,
} from '../../../../utils/native/dynatrace-events';
import { requestLocationPermission } from './location-permission-helpers';

export function LocationInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const backURL = useParamBackUrl('/sites/list');
  const LocationPermissionIcon = createLocationPermissionIcon();

  // This is the earliest screen of the pre-onboarding flow — clear any stale funnel timer
  // left over from an abandoned attempt so it can't leak into this run's permission event.
  useOnMount(() => {
    resetOnboardingFunnelTimer();
  });

  const handleContinue = async () => {
    const granted = await requestLocationPermission();
    trackLocationPermissionOutcome(granted ? 'granted' : 'denied');
    trackDynatraceLocationPermissionOutcome(granted ? 'granted' : 'denied');

    if (granted) {
      navigate('../device-register', { replace: true });
    } else {
      navigate('../location_required_error', { replace: true });
    }
  };

  return (
    <SlidingAnimationPageBase includeTopNav includeTopNavHamButton title={t('Common.device setup')} backURL={backURL}>
      <Center flexDirection="column" px={3} textAlign="center">
        <LocationPermissionIcon data-testid="location-permission-image" h="300px" w="300px" />

        <Heading mt={2} size={'lg'}>
          {t('Location.allow location access')}
        </Heading>
        <Text mt={1}>{t('Location.use location services to make setup')}</Text>
        <ArcButton onClick={handleContinue} mt={8} w={'100%'} arcColor="#3DCD57">
          {t('Common.continue')}
        </ArcButton>
      </Center>
    </SlidingAnimationPageBase>
  );
}
